import { ProjectWizardContext } from 'context/Context';
import PropTypes from 'prop-types';
import { useState } from 'react';

const ProjectWizardProvider = ({
  children,
  className,
  style,
  handleSubmit,
  yupSubmitRef,
  step,
  setStep,
  data,
  setData,
  stepStatus,
  setStepStatus,
  setAction,
  status,
  form,
  handleNavs,
  types
}) => {
  const [scrollToBottom, setScrollToBottom] = useState(true);

  const value = {
    scrollToBottom,
    setScrollToBottom,
    handleSubmit,
    yupSubmitRef,
    step,
    setStep,
    data,
    setData,
    stepStatus,
    setStepStatus,
    setAction,
    status,
    form,
    handleNavs,
    types
  };

  return (
    <div className={className} style={style}>
      <ProjectWizardContext.Provider value={value}>
        {children}
      </ProjectWizardContext.Provider>
    </div>
  );
};

ProjectWizardProvider.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  yupSubmitRef: PropTypes.object.isRequired,
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  data: PropTypes.object,
  setData: PropTypes.func.isRequired,
  stepStatus: PropTypes.object,
  setStepStatus: PropTypes.func.isRequired,
  setAction: PropTypes.func.isRequired,
  handleNavs: PropTypes.func.isRequired,
  status: PropTypes.string,
  form: PropTypes.object,
  types: PropTypes.array.isRequired
};

export default ProjectWizardProvider;
